// extracted by mini-css-extract-plugin
export default {"slick-loading":"s-Zg7","slick-initialized":"cosCL","slick-vertical":"zYWKr"};